import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardHeader from '@material-ui/core/CardHeader'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Styles from './styles'

class DisplayProductCard extends Component {
  render () {
    const { displayProduct, country, language, imsi, classes } = this.props
    return (
      <Card square className={classes.colInside} style={{ minWidth: '300px', maxWidth: '400px' }}>
        <CardHeader
          title={displayProduct.title}
          subheader={displayProduct.subheading}
          style={{ textAlign: 'center' }}
        />
        <div className={classes.imageContainer}>
          <div style={{ maxWidth: '250px', margin: 'auto' }}>
            <img
              src={displayProduct.imagePath}
              style={{ margin: 'auto', width: '100%', height: '100%' }}
              alt='product'
            />
          </div>
        </div>
        <CardContent style={{ paddingTop: 0, marginTop: '0px' }}>
          <Typography variant='subheading' align='center'>
            {country === 'Finland' && language === 'sv' ? displayProduct.information : displayProduct.description}
          </Typography>
        </CardContent>
        <CardActions>
          <a
            href={`${displayProduct.productLink}${imsi ? `?imsi=${imsi}` : ''}`}
            className={classes.themeLink}
            style={{ width: '100%', textDecoration: 'none' }}
            target={'_blank'}
          >
            <Button fullWidth variant='outlined' color='primary'>
              {displayProduct.productLinkText}
              {' '}
              <span style={{ color: '#c60f12', marginLeft: '20px' }}>
                {displayProduct.price}{this.resolvePriceSymbol(country)}{' '}
              </span>
            </Button>
          </a>
        </CardActions>
      </Card>
    )
  }

  resolvePriceSymbol (country) {
    return country === 'Finland' ? '€' : country === 'Sweden' ? ':-' : 'SEK'
  }
}

export default withStyles(Styles)(DisplayProductCard)



// WEBPACK FOOTER //
// ./src/common/display-product-card.js